<template>
  <div class="page_admin_buses">
    <h1>Autobusy</h1>
    <div class="actions">
      <button @click="add" class="add" title="Přidat autobus">
        <i class="fa fa-plus"></i>
      </button>
    </div>
    <tabloid name="buses" :columns="columns" :data="buses">
      <template v-slot:time="{ row }">
        <inputerDatetime :paths="['buses', row.id, 'time']" :time="true" />
      </template>
      <template v-slot:direction="{ row }">
        <inputerSelect
          :paths="['buses', row.id, 'direction']"
          :items="{ TrainToCamp: 'Na turnaj', CampToTrain: 'Z turnaje'}"
        />
      </template>
      <template v-slot:capacity="{ row }">
        <inputerNumber :paths="['buses', row.id, 'capacity']" />
      </template>
      <template v-slot:actions="{ row }">
        <button @click="remove(row)" class="remove" title="Odstranit autobus">
          <i class="fa fa-times"></i>
        </button>
      </template>
    </tabloid>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { data } from "../../store_utils";
import tabloid from "../../components/tabloid.vue";
import inputerNumber from "../../components/inputer-number";
import inputerDatetime from "../../components/inputer-date";
import inputerSelect from "../../components/inputer-select";

export default {
  name: "admin_buses",
  components: {
    tabloid,
    inputerNumber,
    inputerDatetime,
    inputerSelect
  },
  data: () => ({
    columns: {
      time: { title: "Čas" },
      direction: { title: "Směr" },
      capacity: { title: "Kapacita" },
      usedByOther: { title: "Využito" },
      actions: { title: " " },
    }
  }),
  computed: {
    ...mapState(["buses"]),
  },
  methods: {
    add() {
      const id = data.newGuid();
      this.$store.commit("add", {
        paths: ["buses", id],
        value: {
          id: id,
          time: new Date(),
          usedByOther: 0,
          usedByMe: 0
        }
      });
    },
    remove(bus) {
      this.$store.commit("remove", {
        paths: ["buses", bus.id]
      });
    }
  }
};
</script>

<style lang="sass">
@import ../../sass/_components

.page_admin_buses
  @include table-view()
  grid-template-areas: "label add" "table table"
  grid-template-columns: auto 1fr
  grid-column-gap: 1rem
  h1
    grid-area: label
  .add
    grid-area: add
  table
    grid-area: table
    .remove
      @include button-danger()
</style>